import { mainnet, sepolia } from 'viem/chains'
import { isMainnet } from '@injectivelabs/networks'
import type { Hex, Chain, Address } from 'viem'
import type { Network } from '@injectivelabs/networks'

export type TransactionEstimationClient = {
  getTransactionCount: (parameters: { address: Address }) => Promise<number>
  estimateGas: (parameters: {
    data: Hex
    to: Address
    value: bigint
    account: Address
  }) => Promise<bigint>
  estimateFeesPerGas: () => Promise<{
    gasPrice?: bigint
    maxFeePerGas?: bigint
    maxPriorityFeePerGas?: bigint
  }>
}

export const getInjNetworkToChain = (network: Network): Chain => {
  if (isMainnet(network)) {
    return mainnet
  }

  return sepolia
}

export const estimateGasAndNonce = async ({
  from,
  to,
  value,
  calldata,
  publicClient
}: {
  to: Address
  from: Address
  value: bigint
  calldata: `0x${string}`
  publicClient: TransactionEstimationClient
}) => {
  const [gas, fees, nonce] = await Promise.all([
    publicClient.estimateGas({
      account: from,
      to,
      data: calldata,
      value
    }),
    publicClient.estimateFeesPerGas(),
    publicClient.getTransactionCount({ address: from })
  ])

  if (
    fees.maxFeePerGas === undefined ||
    fees.maxPriorityFeePerGas === undefined
  ) {
    throw new Error('EIP-1559 fee estimate is unavailable')
  }

  return {
    gas,
    nonce,
    fees: {
      maxFeePerGas: fees.maxFeePerGas,
      maxPriorityFeePerGas: fees.maxPriorityFeePerGas
    }
  }
}
